import { useTranslation } from 'react-i18next'

import { Alert, Divider, FormatPrice, LineItem, Text } from '@reveni-io/reveni-ui'

import PreviewCanvas from '@/common/components/PreviewCanvas/PreviewCanvas'
import { previewCurrency } from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/constants'

import { getOrderSummaryLines, getOrderSummaryTotals } from './helpers'
import * as Styles from './styles'

const DigitalProductPreview = ({ title, image }) => {
  const { t } = useTranslation()

  const lines = getOrderSummaryLines({ title, image })
  const { itemsCount, subtotal } = getOrderSummaryTotals(lines)

  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="titleM">{t('Vista previa')}</Text>
        <Text type="bodyMRegular">
          {t('Comprueba cómo se ve el producto digital de Return Protection en contexto real.')}
        </Text>
      </Styles.Header>
      <Alert type="info">
        {t(
          'Estás viendo una muestra de ejemplo. El contenido real cambiará según los productos del carrito o el checkout.'
        )}
      </Alert>
      <PreviewCanvas>
        <Styles.OrderSummary>
          <Text type="titleM">{t('Resumen del pedido')}</Text>
          {lines.map(line => (
            <LineItem key={line.id} item={line} />
          ))}
          <Divider />
          <Styles.TotalRow>
            <Text type="bodySRegular">{t('Subtotal · {{count}} artículos', { count: itemsCount })}</Text>
            <Text type="bodySRegular">
              <FormatPrice currency={previewCurrency}>{subtotal}</FormatPrice>
            </Text>
          </Styles.TotalRow>
          <Styles.TotalRow>
            <Text type="bodyMBold">{t('Total')}</Text>
            <Text type="bodyMBold">
              <FormatPrice currency={previewCurrency}>{subtotal}</FormatPrice>
            </Text>
          </Styles.TotalRow>
        </Styles.OrderSummary>
      </PreviewCanvas>
    </Styles.Container>
  )
}

export default DigitalProductPreview
